import UsersService from '../services/UsersService';

class UserStore{
  constructor(){
    this.userData = {
      id: null,
      firstName: null,
      lastName: null,
      group: null,
      groupEntityId: null
    };
    
    // this.fetchUserData();
  }

  async fetchUserData() {
    // Get latest user data from server on hard loads to mitigate localStorage tampering
    try {
      const userRes = await UsersService.getOwn();
      this.setUserData(userRes.data);
    }
    catch(err) {
      console.log({err});
      this.clearUserData();
    }
  }
  
  setUserData(userData){
    this.userData = {
      id: userData.id,
      firstName: userData.firstName,
      lastName: userData.lastName,
      group: userData.group,
      groupEntityId: userData.groupEntityId
    };

    // this.storeUserData();
  }
  
  clearUserData(){
    this.userData = {
      id: null,
      firstName: null,
      lastName: null,
      group: null,
      groupEntityId: null
    };
    
    // this.storeUserData();
  }

  // storeUserData(){
  //   try {
  //     localStorage.setItem('@FoodDrop:UserData', JSON.stringify(this.userData));
  //   }
  //   catch (error) {
  //     // Error saving data
  //     console.log(error)
  //   }
  // }

  // retrieveUserData(){
  //   try {
  //     const value = localStorage.getItem('@FoodDrop:UserData');
  //     if (value !== null) {
  //       this.userData = JSON.parse(value);
  //     }
  //   }
  //   catch (error) {
  //     // Error retrieving data
  //     console.log(error);
  //   }
  // };
}

const userStore = new UserStore();

export default userStore;